const merchandisingMap = {
  CHEAPEST_NONSTOP: {
    label: 'CHEAPEST_NONSTOP',
    longText: 'Save time, save money! No connections!',
    shortText: 'Cheapest Nonstop',
    icon: 'discount',
  },
  EARLY_BIRD: {
    label: 'EARLY_BIRD',
    longText: null,
    shortText: 'Early Bird Flight',
    icon: 'earlyBird',
  },
  BEST_VALUE: {
    label: 'BEST_VALUE',
  },
  ALTERNATE_DATE: {
    label: 'ALTERNATE_DATE',
    longText: 'Fly a different date and save!',
    shortText: 'Alternate Date',
    icon: 'calendar',
  },
}

export function getMerchandisingText({ merchandisingList, flyGaLogic, departingFrom }) {
  let itinMerchandising = {}

  if (merchandisingList && merchandisingList.length > 0) {
    let bestValue = false

    if (merchandisingList.includes('BEST_VALUE')) {
      bestValue = true
      itinMerchandising = merchandisingMap.BEST_VALUE
      flyGaLogic.fire.fireGenericListingsEvent('BEST VALUE MERCHANDISING', 'BEST_VALUE_MERCHANDISING')
    } else if (merchandisingList.includes('ALTERNATE_DATE')) {
      itinMerchandising = merchandisingMap.ALTERNATE_DATE
    } else if (merchandisingList.includes('EARLY_BIRD')) {
      itinMerchandising = merchandisingMap.EARLY_BIRD
      if (departingFrom && departingFrom.cityName) {
        itinMerchandising.longText = `Take off from ${departingFrom.cityName} before 7AM to beat the crowds.`
      } else {
        itinMerchandising.longText = 'Take off before 7AM to beat the crowds.'
      }
    } else if (merchandisingList.includes('CHEAPEST_NONSTOP')) {
      itinMerchandising = merchandisingMap.CHEAPEST_NONSTOP
    }

    if (!bestValue && itinMerchandising.shortText) {
      flyGaLogic.fire.merchandising(itinMerchandising.shortText)
    }
  }

  return itinMerchandising
}
